module.exports = __webpack_public_path__ + "img/sundashboard.2ae6e931.webp";